export enum ContainerType {
  Maszyna = "Maszyna",
  Przewijarka = "Przewijarka",
  W_Planowaniu_Druku = "W planowaniu Druku",

  Zaplanowany_Druk = "Zapl. Druk",
  Zlecenie = "Zlecenie",
  Pracownik = "Pracownik",
}

export interface IItem {
  type: ContainerType;
  _id: string;
  name: string;
}


export interface IContainer {
  type: ContainerType;
  _id: string;
  name: string;

  parents: IContainer[];
  children: IContainer[]
}

export class Container implements IContainer {
  private _id_: string = ""
  private name_: string = ""

  children: IContainer[] = []
  constructor(private parents_: IContainer[], private type_: ContainerType) { }

  get parents(): IContainer[] { return this.parents_ }
  get type(): ContainerType { return this.type_ }
  get _id(): string { return this._id_; }
  get name(): string {
    if (this.name_) return this.name_
    else return this.type
  }

  set name(name_: string) {
    this.name_ = name_
  }

  set id(id_: string) {
    this._id_ = id_
  }
}
